import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import Article from 'ui/Icons/components/Article.component';
import { theme } from '../../../../tailwind.config';
import classNames from 'classnames';
import { IContentFileUpload } from '../types';

interface IContentDocumentProps {
  className?: string;
  document: IContentFileUpload;
  index: number;
  onClick?: (index: number) => void;
}

export const ContentDocument = ({
  className,
  document,
  index,
  onClick,
}: IContentDocumentProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick(index);
    }
  };

  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center p-2 bg-gray-20 rounded cursor-pointer',
        className
      )}
      onClick={handleClick}
    >
      {/* Document Icon */}
      <div className="flex items-center justify-center h-[50px]">
        <SvgIcon
          IconComponent={Article}
          defaultFill={theme.colors['brown-100']}
          hoverFill={theme.colors['brown-hard']}
          defaultBackground={theme.colors['transparent']}
          width="24px"
          height="24px"
        />
      </div>
      
      {/* Document Name */}
      <span className="text-[12px] font-pt-sans text-gray-100 text-center mt-1 leading-tight uppercase">
        {document.displayName}
      </span>
    </div>
  );
};